import { Injectable } from "@angular/core";
import { reportProgress } from "@ankaadia/ankaadia-shared-frontend";
import { GetKnownVarsGQL, KnownVarsNode } from "@ankaadia/graphql";
import { TreeNode } from "primeng/api";
import { Observable, map } from "rxjs";

@Injectable({ providedIn: "root" })
export class KnownVariablesService {
  constructor(private readonly getKnownVarsQuery: GetKnownVarsGQL) {}

  getKnownVars(): Observable<TreeNode[]> {
    return this.getKnownVarsQuery.subscribe().pipe(
      map((result: any) => result.data.getKnownVars),
      reportProgress("getKnownVars", "1", false, { silent: true }),
      map((data: any) => this.formatKnownVars(data.knownVars))
    );
  }

  formatKnownVars(knownVars: KnownVarsNode[]): TreeNode[] {
    const rootKnownVars = knownVars.filter((node) => node.parentKey == null);

    const knownVarTree = rootKnownVars.map((node) => {
      const childNodes = knownVars.filter((child) => child.parentKey === node.key);
      const treeNode: TreeNode = {
        key: node.key,
        label: node.label,
        data: node.data,
        children: childNodes.map((child) => this.buildChildNodes(child, knownVars)),
      };

      return treeNode;
    });

    return knownVarTree;
  }

  buildChildNodes(node: TreeNode, knownVars: KnownVarsNode[]): TreeNode {
    const childNodes = knownVars.filter((child) => child.parentKey === node.key);
    return {
      key: node.key,
      label: node.label,
      data: node.data,
      children: childNodes.map((child) => this.buildChildNodes(child, knownVars)),
    };
  }
}
